export default "__VITE_ASSET__Cz1TfJoK__"